import ReviewVideo from "../components/ReviewVideo";
import { hideLoader, showLoader } from "./loader";

/**
 * ВАЖНО ДЛЯ SAFARI:
 * Видео должны быть:
 * - mp4
 * - h264 codec
 * - aac audio
 * - faststart
 *
 * ffmpeg:
 * ffmpeg -i input.mp4 -vcodec libx264 -acodec aac -movflags +faststart output.mp4
 */

const demoVideos = [
  {
    url: "./media/reviews/video-2.mp4",
    previewImage: "./media/reviews/video-2.jpg",
  },

  {
    url: "./media/reviews/video-3.mp4",
    previewImage: "./media/reviews/video-3.jpg",
  },

  {
    url: "./media/reviews/video-4.mp4",
    previewImage: "./media/reviews/video-4.jpg",
  },
];

/**
 * Проверка iOS
 */
function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent);
}

/**
 * Проверка Safari
 */
function isSafari() {
  return /^((?!chrome|android).)*safari/i.test(
    navigator.userAgent
  );
}

/**
 * Для Safari всегда используем mp4
 */
function getOptimalVideoUrl(videoData) {
  // Safari/iPhone/iPad
  if (isIOS() || isSafari()) {
    return videoData.url;
  }

  return videoData.url;
}

export default async function getReviewsVideo() {
  const wrapperEl = document.querySelector(
    ".reviews__slider2 .swiper-wrapper"
  );

  if (!wrapperEl) {
    console.error(
      "Не найден .reviews__slider2 .swiper-wrapper"
    );

    return Promise.reject("Wrapper not found");
  }

  const wrapEl = wrapperEl.closest(".reviews__wrapper");

  let loader = null;

  if (wrapEl) {
    loader = showLoader();

    wrapEl.append(loader);
  }

  const videoSlider = document.querySelector(
    ".reviews__slider2"
  );

  try {
    // Прячем слайдер пока грузим
    if (videoSlider) {
      videoSlider.style.opacity = "0";
      videoSlider.style.visibility = "hidden";
    }

    // Очищаем
    wrapperEl.innerHTML = "";

    // console.log("Начинаем загрузку видео...");

    // Создаем слайды
    demoVideos.forEach((videoData, index) => {
      try {
        const optimalUrl =
          getOptimalVideoUrl(videoData);

        // console.log(
        //   `Добавляем видео ${index + 1}:`,
        //   optimalUrl
        // );

        const reviewVideo = new ReviewVideo({
          url: optimalUrl,

          /**
           * ВАЖНО:
           * НЕ generatePreviewFromVideo()
           * Safari плохо работает с canvas + video
           */

          previewImage:
            videoData.previewImage || "",
        });

        const slide = reviewVideo.getSlide();

        wrapperEl.appendChild(slide);

        // console.log(
        //   `Видео ${index + 1} успешно добавлено`
        // );
      } catch (error) {
        console.error(
          `Ошибка создания видео ${index + 1}:`,
          error
        );
      }
    });

    // console.log(
    //   `Всего загружено ${demoVideos.length} видео`
    // );

    /**
     * SWIPER
     */

    if (window.Swiper) {
      const swiperContainer =
        wrapperEl.closest(".swiper");

      if (swiperContainer) {
        // Уничтожаем старый swiper
        if (swiperContainer.swiper) {
          swiperContainer.swiper.destroy(
            true,
            true
          );
        }

        new window.Swiper(swiperContainer, {
          slidesPerView: 1,

          spaceBetween: 20,

          loop: false,

          speed: 600,

          observer: true,
          observeParents: true,

          preloadImages: false,

          watchSlidesProgress: true,

          updateOnImagesReady: true,

          passiveListeners: false,

          touchStartPreventDefault: false,

          navigation: {
            nextEl:
              swiperContainer.querySelector(
                ".swiper-button-next"
              ),

            prevEl:
              swiperContainer.querySelector(
                ".swiper-button-prev"
              ),
          },

          pagination: {
            el: swiperContainer.querySelector(
              ".swiper-pagination"
            ),

            clickable: true,
          },

          breakpoints: {
            768: {
              slidesPerView: 2,
            },

            1024: {
              slidesPerView: 3,
            },
          },

          on: {
            init() {
              console.log(
                "Swiper initialized"
              );
            },

            slideChange() {
              /**
               * Ставим все видео на паузу
               * при смене слайда
               */

              document
                .querySelectorAll(".main-video")
                .forEach((video) => {
                  try {
                    video.pause();

                    video.currentTime = 0;
                  } catch (e) {
                    console.warn(e);
                  }
                });
            },
          },
        });
      }
    }

    // Показываем слайдер
    requestAnimationFrame(() => {
      if (videoSlider) {
        videoSlider.style.opacity = "1";
        videoSlider.style.visibility = "visible";
      }
    });

    return demoVideos;
  } catch (error) {
    console.error(
      "Ошибка загрузки видео отзывов:",
      error
    );

    wrapperEl.innerHTML = "";

    const errorEl = document.createElement("div");

    errorEl.className = "reviews-video-error";

    errorEl.textContent =
      "Ошибка загрузки видео отзывов";

    wrapperEl.appendChild(errorEl);

    throw error;
  } finally {
    // Loader
    try {
      hideLoader();

      if (loader?.remove) {
        loader.remove();
      }
    } catch (e) {
      console.warn(e);
    }
  }
}

/**
 * Export utils
 */

export {
  isIOS,
  isSafari,
  getOptimalVideoUrl,
};